import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ResultadosComponent } from './modules/resultados/resultados.component';
import { Router, ActivatedRoute, RoutesRecognized, NavigationEnd  } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';

@Component({
  selector: 'app-vuelos',
  templateUrl: './vuelos.component.html',
  styleUrls: ['./vuelos.component.scss']
})
export class VuelosComponent implements OnInit {
  @ViewChild(ResultadosComponent) resultados: ResultadosComponent;

  private previousUrl: string = undefined;
  private currentUrl: string = undefined;
  public banner: boolean = true;

  constructor(
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.titleService.setTitle('Mundo Joven - Vuelos');
    this.getUrl();
  }

  ngOnInit() {
  }

  getUrl(){
    this.currentUrl = this.router.url;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        if (this.currentUrl === '/m/vuelos/form/step-one' || this.currentUrl === '/m/vuelos/gracias-vuelos/pendiente') {
          this.banner = false;
        }else{
          this.banner = true;
        }
      };
    });
  }

}
